import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import {
  MatError,
  MatFormField,
  MatInput,
  MatLabel,
} from '@angular/material/input';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { exportAsCsvFile } from '../shared/function/exportDataToCsv';
@Component({
  selector: 'app-device-state-config',
  templateUrl: './device-state-config.component.html',
  styleUrls: ['./device-state-config.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatIcon,
    NgxPaginationModule,
    ReactiveFormsModule,
    MatFormField,
    MatError,
    MatLabel,
    MatInput,
    CommonPaginationComponent,
  ],
})
export class DeviceStateConfigComponent implements OnInit {
  isUploaded = false;

  file: File | null = null;
  fileNameForm: FormGroup = this.formBuilder.group({});

  size = 10;
  page = 1;
  totalLength = 0;
  Responses = [];

  userPermission = [];

  constructor(
    private formBuilder: FormBuilder,
    public apiMicroservice: ApiServiceService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setDeviceStateConfigForm();
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'Device State Config' &&
          element.view === false
        ) {
          this.navigateBack();
        }
      }
    );
  }

  setDeviceStateConfigForm() {
    this.fileNameForm = this.formBuilder.group({
      fileName: ['', [Validators.required]],
    });
    this.file = null;
    this.isUploaded = false;
    this.Responses = [];
    this.size = 10;
    this.page = 1;
    this.totalLength = 0;
  }

  downloadMyFile(): void {
    const link: HTMLAnchorElement = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute(
      'href',
      '../../assets/downloadableSampleFiles/Sample_Save_Device_State.csv'
    );
    link.setAttribute('download', 'Sample_Save_Device_State.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Remove the link after the download is complete
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const selectedFile = input.files[0];
      this.file = selectedFile; // Store the selected file
      // Update form fields
      this.fileNameForm.patchValue({
        fileName: selectedFile.name, // Store file name
      });
    } else {
      this.file = null;
      // Reset values if no file is selected
      this.fileNameForm.patchValue({
        fileName: '',
      });
    }
  }

  saveDeviceStateConfigDetails(e: Event) {
    e.preventDefault();
    if (this.file) {
      this.spinner.show();
      this.isUploaded = true;
      const formData = new FormData();
      formData.append('file', this.file);
      this.apiMicroservice.saveDeviceState(formData).subscribe({
        next: (res) => {
          this.Responses = res.data;
          this.totalLength = res.data.length;
          this.file = null;
          this.apiMicroservice.openSnackbar(res.message);
          this.spinner.hide();
        },
        error: (err) => {
          this.apiMicroservice.openSnackbar(err.error.message);
          this.spinner.hide();
        },
      });
    } else {
      this.apiMicroservice.openSnackbar('Please Select File');
    }
  }

  onPageChange(event: number) {
    this.page = event;
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
  }

  DownloadOutputReport() {
    try {
      this.spinner.show();
      const exportData = this.Responses.map((el) => {
        const obj = {
          IMEI: el.imei || '--',
          State: el.state || '--',
          Status: el.message,
        };
        return obj;
      });
      exportAsCsvFile(exportData, 'Device_State_Uploaded_Files_Report');
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error(error);
    }
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
